import { buildCategoriesMap, normalizeModiScheme } from '@/helpers/menu'

export default {
    SET_MENU(state, items) {
        if (!Array.isArray(items)) {
            state.products = []
            return
        }

        state.products = items.map(item => {
            const modiScheme = normalizeModiScheme(item.modi_scheme)

            return {
                id: item.id,
                category_name: item.category_name,
                category_id: item.parent_id,
                composition: item.composition,
                name: item.name,
                description: item.description,
                image: item.image,
                rk_id: item.rkeeper_id,
                price: item.price ?? 0,
                modi_scheme: modiScheme,
                menu_item_params: item.parameters,
            }
        })
    },

    SET_TO_MENU_CATEGORIES(state, categories) {
        if (!Array.isArray(categories)) {
            state.categories = {}
            return
        }

        state.categories = buildCategoriesMap(categories)
    },
}
